import { useState, useEffect } from 'react';
import '../styles/Library.css';
import { useTranslation } from 'react-i18next';

import Nav from './Nav';

const URL_BACKEND = process.env.REACT_APP_URL_BACKEND;


function Library() {  
  const { t } = useTranslation();
  
  const [characters, setCharacters] = useState([]);
  const [items, setItems] = useState([]);
  const [games, setGames] = useState([]);
  const [swords, setSwords] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const charactersResponse = await fetch(`${URL_BACKEND}/api/characters`);
        const charactersData = await charactersResponse.json();
        setCharacters(charactersData);

        const itemsResponse = await fetch(`${URL_BACKEND}/api/items-list`);
        const itemsData = await itemsResponse.json();
        setItems(itemsData);

        const gamesResponse = await fetch(`${URL_BACKEND}/api/games`);
        const gamesData = await gamesResponse.json();
        setGames(gamesData);

        const swordsResponse = await fetch(`${URL_BACKEND}/api/swords`);
        const swordsData = await swordsResponse.json();
        setSwords(swordsData);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
        <Nav />
      <div className="library">
        <h1>{t('library.title')}</h1>

        { 
            // CHARACTERS 
        }
        <div className="library-section">
          <h2>{t('library.characters')}</h2> 
            <ul className="library-list">
            {characters.map((character) => (
              <li key={`character-${character.id_personnage}`} className="library-item">
                <img src={`/images/characters/${character.image_personnage}`} alt={character.nom_personnage} className="library-item-image" />{character.nom_personnage}
              </li>
            ))}
            </ul>
        </div>

        { 
            // ITEMS
        }
        <div className="library-section">
          <h2>{t('library.items')}</h2>
          <div className="library">
            {items
            .filter((item, index, self) => self.findIndex((i) => i.id_jeu === item.id_jeu) === index)
            .map(({ id_jeu, nom_jeu, acronyme_jeu }) => (
              <div key={`item-${id_jeu}`} className="library-item-group">
                <span className="library-item-title">{nom_jeu} ({acronyme_jeu})</span>
                <ul className="library-list">
                  {items
                    .filter((item) => item.id_jeu === id_jeu)
                    .map((item) => (
                      <li key={`item-${item.id_item}`} className="library-item">
                        <img src={`/images/items/${item.img_item}`} alt={item.nom_item} className="library-item-image" />{item.nom_item}
                      </li>
                    ))
                  }
                </ul>
              </div>
            ))}
          </div>
        </div>

        { 
            // GAMES
        }
        <div className="library-section">
          <h2>{t('library.games')}</h2> 
            <ul className="library-list">
            {games.map((game) => (
              <li key={`game-${game.id_jeu}`} className="library-item">
                <img src={`/images/games/${game.img_jeu}`} alt={game.nom_jeu} className="library-item-image" />{game.nom_jeu}
              </li>
            ))}
            </ul>
        </div>

        { 
          // SWORDS
        }
        <div className="library-section">
          <h2>{t('library.swords')}</h2> 
            <ul className="library-list">
            {swords.map((sword) => (
              <li key={`sword-${sword.id_epee}`} className="library-item">
                <img src={`/images/swords/${sword.image_epee}`} alt={sword.nom_epee} className="library-item-image" />{sword.nom_epee}
              </li>
            ))}
            </ul>
        </div>
      </div>
    </div>
  );
}

export default Library;